<template>
  <div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add Subscription</p>
      </header>
      <section class="modal-card-body">
        <form @submit.prevent="confirmAddSubscription">
          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">Type</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <div class="select">
                    <select v-model="type">
                      <option value="standard">Standard</option>
                      <option value="premium">Premium</option>
                      <option value="webgps">Web GPS</option>
                      <option value="gps1">GPS 1 device</option>
                      <option value="gps2">GPS 2 devices</option>
                      <option value="gps3">GPS 3 devices</option>
                      <option value="gps4">GPS 4 devices</option>
                      <option value="gps5">GPS 5 devices</option>
                      <option value="gps6">GPS 6 devices</option>
                      <option value="gps7">GPS 7 devices</option>
                      <option value="gps8">GPS 8 devices</option>
                      <option value="gps9">GPS 9 devices</option>
                      <option value="gps10">GPS 10 devices</option>
                      <option value="gps11">GPS 11 devices</option>
                      <option value="gps12">GPS 12 devices</option>
                      <option value="gps13">GPS 13 devices</option>
                      <option value="gps14">GPS 14 devices</option>
                      <option value="gps15">GPS 15 devices</option>
                      <option value="gps16">GPS 16 devices</option>
                      <option value="gps17">GPS 17 devices</option>
                      <option value="gps18">GPS 18 devices</option>
                      <option value="gps19">GPS 19 devices</option>
                      <option value="gps20">GPS 20 devices</option>
                    </select>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="field is-horizontal">
            <div class="field-label is-normal">
              <label class="label">Expires</label>
            </div>
            <div class="field-body">
              <div class="field">
                <div class="control">
                  <FlatPickr v-model="expires" :config="expiresDateConfig" class="input" />
                </div>
              </div>
            </div>
          </div>

          <input type="submit" style="display: none" />
        </form>

        <!-- Error notification section -->
        <div class="notification is-danger" v-if="addError">
          {{ addError }}
        </div>
      </section>
      <footer class="modal-card-foot">
        <div class="container">
          <div class="is-pulled-right">
            <button class="button" @click="cancelAddSubscription" :disabled="isAdding">
              Cancel
            </button>
            <button
              class="button is-primary"
              @click="confirmAddSubscription"
              :class="{ 'is-loading': isAdding }"
              :disabled="isAdding"
            >
              Add
            </button>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import FlatPickr from 'vue-flatpickr-component'

import { ADD_SUBSCRIPTION } from './userStore'

export default {
  name: 'UserAddSubscriptionModal',

  components: { FlatPickr },

  props: {
    userStorePath: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      type: 'standard',
      expires: null,
      isAdding: false,
      addError: undefined
    }
  },

  mounted() {
    this.expires = new Date()
  },

  computed: {
    expiresDateConfig() {
      return {
        enableTime: false,
        dateFormat: 'Y-m-d',
        minDate: new Date(),
        locale: {
          firstDayOfWeek: 1
        }
      }
    }
  },

  methods: {
    cancelAddSubscription() {
      this.$emit('cancelled')
    },

    async confirmAddSubscription() {
      var expires = dayjs(this.expires)
        .add(1, 'day')
        .toDate()
      expires.setUTCHours(21)
      expires.setUTCMinutes(59)
      expires.setUTCSeconds(59)
      expires.setUTCMilliseconds(999)

      this.addError = undefined
      this.isAdding = true

      try {
        const addSubscriptionAction = `${this.userStorePath}/${ADD_SUBSCRIPTION}`
        await this.$store.dispatch(addSubscriptionAction, { type: this.type, expires })

        this.$emit('succeeded')
      } catch (error) {
        this.addError = error || 'Something went wrong.'
      } finally {
        this.isAdding = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-card-head {
  border-bottom: 0;
}

.modal-card-foot {
  border-top: 0;
}

.notification {
  margin-top: 1em;
}
</style>
